import { actionHelpers } from 'companion-app-components/flux/core';

// Special action to adjust transactions after a GET
export const autoCategorizeTransactions =
  actionHelpers.createAction('AUTO_CATEGORIZE_TRANSACTIONS');

// Special action to adjust transactions after a GET
export const updateTransactionCategoriesForPayeeAction =
actionHelpers.createAction('UPDATE_TRANSACTION_CATEGORIES_FOR_PAYEE_ACTION');
